// import { DataService } from './DataService'; // Import your DataService
import Cookies from 'js-cookie';
import actions from './actions';
import store from '../store'; // Import your Redux store
import { DataService } from '../../config/dataService/dataService';
import { getItem } from '../../utility/localStorageControl';

export const validateUser = async (navigate) => {
  const accessToken = Cookies.get('access_token') || getItem('access_token');
  if (!accessToken) {
    // console.log('No access token found.');
    return; // Exit if no token is found
  }

  try {
    const response = await DataService.post('/auth/auth');
    if (response.data.status) {
      const { data } = response.data;
      // Update Redux store with user data
      store.dispatch(actions.loginSuccess(true, data));

      if (navigate) {
        navigate(`/${data.api_url}/dashboard`);
      }
      // console.log('User validated and Redux updated:', data);
    } else {
      // console.error('Token validation failed:', response.data.message);
      // Optionally, clear the invalid token
      Cookies.remove('access_token');
      Cookies.remove('logedIn');
    }
  } catch (error) {
    // console.error('Error validating token:', error);
    // Clear invalid token on error
    Cookies.remove('access_token');
    Cookies.remove('logedIn');
  }
};
